import { useState, useCallback } from 'react';
import { PlayerInfo, Invitation } from '../types/game';
import { Socket } from 'socket.io-client';

export const useLobby = (socket: Socket | null) => {
  const [onlinePlayers, setOnlinePlayers] = useState<PlayerInfo[]>([]);
  const [currentPlayer, setCurrentPlayer] = useState<PlayerInfo | null>(null);
  const [pendingInvitation, setPendingInvitation] = useState<Invitation | null>(null);
  const [isInLobby, setIsInLobby] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const joinLobby = useCallback((playerName: string) => {
    if (socket) {
      setError(null);
      socket.emit('join-lobby', playerName);
    }
  }, [socket]);

  const invitePlayer = useCallback((playerId: string) => {
    if (socket) {
      socket.emit('invite-player', playerId);
    }
  }, [socket]);

  const acceptInvitation = useCallback((invitationId: string) => {
    if (socket) {
      socket.emit('accept-invitation', invitationId);
      setPendingInvitation(null);
    }
  }, [socket]);

  const rejectInvitation = useCallback((invitationId: string) => {
    if (socket) {
      socket.emit('reject-invitation', invitationId);
      setPendingInvitation(null);
    }
  }, [socket]);

  const leaveLobby = useCallback(() => {
    setIsInLobby(false);
    setOnlinePlayers([]);
    setCurrentPlayer(null);
    setPendingInvitation(null);
    setError(null);
  }, []);

  return {
    onlinePlayers,
    currentPlayer,
    pendingInvitation,
    isInLobby,
    error,
    joinLobby,
    invitePlayer,
    acceptInvitation,
    rejectInvitation,
    leaveLobby,
    setOnlinePlayers,
    setCurrentPlayer,
    setPendingInvitation,
    setIsInLobby,
    setError
  };
};